import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useObjectReplace = defineStore('object_replace', () => {
  const data = ref({
    object_from: 0,
    object_type: 0,
    object_name: '',
    object_to: 0,
  })
  const open = ref(false)

  /**
   * Задать заменяемый объект
   * @param value
   * @param name
   * @param type
   */
  const setObjectFrom = (value: number, name: string, type: number) => {
    data.value = {
      ...data.value,
      object_from: value,
      object_name: name,
      object_type: type,
    }
    open.value = true
  }

  /**
   * Задать объект замены
   * @param value
   */
  const setObjectTo = (value: number) => {
    data.value = {
      ...data.value,
      object_to: value,
    }
  }

  /**
   * Очистить и скрыть форму
   */
  const clearObjects = () => {
    data.value = {
      object_from: 0,
      object_type: 0,
      object_name: '',
      object_to: 0,
    }
    open.value = false
  }

  return {
    data,
    open,

    setObjectFrom,
    setObjectTo,
    clearObjects,
  }
})
